import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { CoreModule, FormComponent, OffersType } from '@toevla-webapplications/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CampFormComponent } from '../camp-form/camp-form.component';
import { BookingService } from '../../../../../../services/booking/booking.service';

@Component({
    selector: 'ivva-booking-first-camp',
    templateUrl: './booking-first-camp.component.html',
    styleUrls: ['./booking-first-camp.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule, CampFormComponent]
})
export class BookingFirstCampComponent extends FormComponent implements OnInit {
	@ViewChild(CampFormComponent)
	campForm: CampFormComponent;

	protected readonly MAX_CHARS_INFO = 200;
	protected readonly OffersType = OffersType;

	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);

	ngOnInit() {
		const data = this.bookingService.getCurrentBooking();

		this.form = this.fb.group({
			extraInfo: [data.extraInfo, Validators.maxLength(this.MAX_CHARS_INFO)],
		});
	}

	override isFormValid(triggerErrors: boolean = true): boolean {
		const valid = super.isFormValid(triggerErrors);
		return valid && this.campForm.isFormValid(triggerErrors);
	}

	override getFormData(): any {
		const data = this.bookingService.getCurrentBooking();
		const camps = data.camps!.filter((c) => c.priority !== 1);

		const firstCamp = this.campForm.getFormData();

		return {
			...super.getFormData(),
			camps: [...camps, firstCamp],
		};
	}
}
